import { has } from 'lodash';
import { GetOrganisationQuery } from 'src/graphql/generated';

export const slackConfigurationSectionVm = ({
  organisation,
}: {
  organisation?: GetOrganisationQuery['organisation'];
}) => {
  const slackIntegrations = organisation?.slackIntegrations ?? [];

  return {
    workspaces: slackIntegrations.map((integration) => ({
      teamId: integration.teamId,
      workspaceName: integration.workspaceName,
      hasInstalled: Boolean(integration.installedAt),
      installedAt: integration.installedAt,
    })),
    hasIntegration: slackIntegrations.length > 0,
    hasAtLeastOneInstallation: slackIntegrations.some(
      (integration) =>
        has(integration, 'installedAt') && integration.installedAt,
    ),
  };
};
